import {
  Add_Regions,
  Delete_one_Regions,
  Get_All_Regions,
  Get_Error,
  Get_one_Regions,
  Update_one_Regions,
} from '../Types';

const intial = {
  Region: [],
  UpdateRegion: [],
  loading: true,
};

const Region_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_Regions:
      return {
        ...state,
        Region: action.payload,
        loading: false,
      };
    case Get_All_Regions:
      return {
        ...state,
        Region: action.payload,
        loading: false,
      };
    case Delete_one_Regions:
      return {
        ...state,
        Region: action.payload,
        loading: false,
      };
    case Update_one_Regions:
      return {
        ...state,
        UpdateRegion: action.payload,
        loading: false,
      };

    case Get_one_Regions:
      return {
        ...state,
        Region: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Region: action.payload,
      };
    default:
      return state;
  }
};

export default Region_Reducer;
